var map = {
	"./decidim/avatar-multiuser.png": 49241,
	"./decidim/brands/google.svg": 43764,
	"./decidim/cc-badge.png": 60783,
	"./decidim/decidim-logo.svg": 86251,
	"./decidim/default-avatar.svg": 79663,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 97333,
	"./decidim/icons.svg": 16942,
	"./decidim/pattern.png": 11965,
	"./decidim/placeholder-card-g.svg": 72338,
	"./decidim/placeholder-card-l.svg": 60441,
	"./decidim/placeholder.jpg": 93192,
	"./decidim/remixicon.symbol.svg": 61162,
	"./decidim/vendor/leaflet/layers-2x.png": 38503,
	"./decidim/vendor/leaflet/layers.png": 31534,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 80291,
	"./decidim/vendor/leaflet/marker-icon.png": 27706,
	"./decidim/vendor/leaflet/marker-shadow.png": 25417,
	"./decidim/vendor/social-share-button/douban.svg": 17133,
	"./decidim/vendor/social-share-button/email.svg": 26350,
	"./decidim/vendor/social-share-button/facebook.svg": 19622,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 61098,
	"./decidim/vendor/social-share-button/hacker_news.svg": 49982,
	"./decidim/vendor/social-share-button/linkedin.svg": 62820,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 24061,
	"./decidim/vendor/social-share-button/pinterest.svg": 56280,
	"./decidim/vendor/social-share-button/reddit.svg": 98098,
	"./decidim/vendor/social-share-button/telegram.svg": 8435,
	"./decidim/vendor/social-share-button/tumblr.svg": 49584,
	"./decidim/vendor/social-share-button/twitter.svg": 32211,
	"./decidim/vendor/social-share-button/vkontakte.svg": 37561,
	"./decidim/vendor/social-share-button/wechat.svg": 6796,
	"./decidim/vendor/social-share-button/whatsapp.svg": 52260,
	"./decidim/vendor/social-share-button/x.svg": 34486,
	"./decidim/vendor/social-share-button/xing.svg": 20610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96198;